import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokentendencia: "",
    webtendencia: []
  },
  mutations: {
    login(state, data) {
      state.webtendencia = data.user;
      state.tokentendencia = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.webtendencia = [];
      state.tokentendencia = "";
    },
    webtendencia(state, data) {
      state.webtendencia = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("webtendencia", data);
    }
  }
});
